import React from 'react';

import { Box, Typography, IconButton } from '@mui/material';
import _ from 'lodash';

import { ReactComponent as ChevronDownIcon } from '../../../../common/assets/icons/chevron_down_icon.svg';
import { SheetCode } from '../../../../common/types/Codes';

type Props = {
  code: SheetCode;
};

const SheetCodeCell: React.FC<Props> = ({ code }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const handleRotate = () => setIsOpen(!isOpen);
  const rotate = isOpen ? 'rotate(180deg)' : 'rotate(0)';

  const renderRow = (workRVU: string, totalRVU: string, bottom: boolean) => {
    return (
      <Box
        className='row'
        sx={{
          position: 'relative',
          ml: '30px',
          mt: '16px',
        }}
      >
        {code.work_rvu && (
          <Box className='row' sx={{ marginRight: '35px' }}>
            <Typography
              sx={{ marginRight: '8px' }}
              fontFamily={'SFProDisplay-Bold'}
            >
              {workRVU}
            </Typography>
            <Typography
              color='textFlorenceSecondary.main'
              fontFamily={'SFProDisplay-Regular'}
            >
              Work RVU
            </Typography>
          </Box>
        )}
        {code.facility_total && (
          <Box className='row'>
            <Typography
              sx={{ marginRight: '8px' }}
              fontFamily={'SFProDisplay-Bold'}
            >
              {totalRVU}
            </Typography>
            <Typography
              color='textFlorenceSecondary.main'
              fontFamily={'SFProDisplay-Regular'}
            >
              Total NF-RVU
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  const modifierText = (modifiers: string[], multiplier: number) => {
    if (_.isEmpty(modifiers) && multiplier <= 1) return '';
    if (_.isEmpty(modifiers)) return '';
    const multStr = multiplier <= 1 ? ')' : ` Units - ${multiplier})`;
    const modStr = modifiers.length > 1 ? 'Modifiers' : 'Modifier';
    return (
      '(' +
      modStr +
      ' - ' +
      modifiers.join('; ') +
      `${multiplier <= 1 ? '' : '; '}` +
      multStr
    );
  };

  return (
    <Box className='table-view-cell-container-white'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <IconButton
          style={{
            transform: rotate,
            transition: 'all 0.25s ease-in-out',
            alignSelf: 'flex-start',
          }}
          onClick={() => handleRotate()}
          className={`${isOpen ? 'icon-selected' : 'icon'}`}
        >
          <ChevronDownIcon />
        </IconButton>
        <Box sx={{ textAlign: 'left' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginLeft: '16px',
              whiteSpace: 'break-spaces',
              marginBottom: '10px',
            }}
          >
            <Typography fontFamily={'SFProDisplay-Bold'} color='primary'>
              {code.code}{' '}
            </Typography>
            <Typography noWrap color='secondary'>
              {modifierText(code.modifiers, code.multiplier)}
            </Typography>
          </div>
          <Typography>{code.description}</Typography>
        </Box>
      </Box>
      {isOpen && (
        <Box
          sx={{
            mt: '8px',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {renderRow(code.work_rvu ?? '', code.facility_total ?? '', false)}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SheetCodeCell;
